import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

const Sidebar = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const navItems = [
    { type: "link", label: t("nav.home"), to: "/" },
    {
      type: "group",
      label: t("nav.gear"),
      children: [
        { label: t("nav.riffleSystems"), to: "/riffle-systems" },
        { label: t("nav.apparel"), to: "/apparel" },
      ],
    },
    { type: "link", label: t("nav.experience"), to: "/experience" },
    { type: "link", label: t("nav.about"), to: "/about" },
  ];

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity duration-400 ${
          isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      />

      <div
        style={{ backgroundColor: "#fff", zIndex: 50 }}
        className={`fixed top-0 left-0 h-full w-[85%] max-w-sm sm:w-96 flex flex-col transition-transform duration-500 ease-in-out ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-black/10">
          <span className="text-black text-lg font-bold uppercase tracking-widest">
            {t("common.brand")}
          </span>
          <button
            onClick={onClose}
            aria-label={t("nav.closeMenu")}
            className="text-black hover:opacity-60 transition-opacity duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <nav className="flex flex-col px-6 py-8 gap-5 overflow-y-auto">
          {navItems.map((item) =>
            item.type === "link" ? (
              <Link
                key={item.to}
                to={item.to}
                onClick={onClose}
                className="text-black hover:opacity-60 text-sm font-medium uppercase tracking-wider transition-opacity duration-200"
              >
                {item.label}
              </Link>
            ) : (
              <div key={item.label} className="flex flex-col gap-3">
                <span className="text-black text-sm font-bold uppercase tracking-wider">
                  {item.label}
                </span>
                <div className="flex flex-col gap-3 pl-4 border-l border-black/10">
                  {item.children.map((child) => (
                    <Link
                      key={child.to}
                      to={child.to}
                      onClick={onClose}
                      className="text-black/80 hover:opacity-60 text-sm font-medium uppercase tracking-wider transition-opacity duration-200"
                    >
                      {child.label}
                    </Link>
                  ))}
                </div>
              </div>
            ),
          )}
        </nav>

        <div className="mt-auto px-6 py-6 border-t border-black/10">
          <LanguageSwitcher />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
